import { gql } from '@apollo/client';

const DELETE_OBJECTIVE_MUTATION = gql`
    mutation deleteObjective( $input: DeleteObjectiveInput! ) {
        result: deleteObjective( input: $input ) {
            affectedRows
        }
    } 
`;

export default DELETE_OBJECTIVE_MUTATION;
